<template>
  <v-form>
    <v-row>
      <div style="width: 40%; display: flex">
        <v-col cols="12" sm="4" md="6" >
          <label class="mr-2">من تاريخ</label>
          <PickerInput label="من تاريخ" @dateValue="targetStartDate($event)" />
        </v-col>

        <v-col cols="12" sm="4" md="6">
          <label class="mr-2">الي تاريخ</label>
          <PickerInput label="الي تاريخ" @dateValue="targetEndDate($event)" />
        </v-col>
      </div>

      <div style="width: 28%; display: flex;margin-top: 37px">
        <div class="button" style="background: white !important">
          <input
              type="radio"
              id="a15"
              name="check-substitution-2"
              :checked="filterObj.range === ''"
              @change="filterObj.range = $event.target.value"
              value=""
          />
          <label class="btn btn-default" for="a25">مسح</label>
        </div>
        <div class="button" style="background: white !important">
          <input
              type="radio"
              id="a25"
              name="check-substitution-2"
              :checked="filterObj.range === 'all'"
              @change="filterObj.range = $event.target.value"
              value="all"
          />
          <label class="btn btn-default" for="a25">الكل</label>
        </div>
        <div class="button" style="background: white !important">
          <input
              type="radio"
              id="a50"
              name="check-substitution-2"
              :checked="filterObj.range === 'day'"
              @change="filterObj.range = $event.target.value"
              value="day"
          />
          <label class="btn btn-default" for="a50">اليوم</label>
        </div>
        <div class="button" style="background: white !important">
          <input
              type="radio"
              id="a75"
              name="check-substitution-2"
              :checked="filterObj.range === 'week'"
              @change="filterObj.range = $event.target.value"
              value="week"
          />
          <label class="btn btn-default" for="a75">الاسبوع</label>
        </div>
      </div>

      <div style="width: 32%; display: flex; margin-top:  37px">
        <v-col cols="12" sm="6" md="6">
          <v-text-field
              label="عدد الايام"
              v-model="filterObj.dayNumber"
              outlined
              dense
          ></v-text-field>
        </v-col>
        <v-col cols="12" sm="6" md="6">
          <v-btn
              depressed
              color="primary"
              style="width: 100%"
              @click="handleFilter()"
          >
            بحث
          </v-btn>
        </v-col>
      </div>
    </v-row>
  </v-form>
</template>

<script>
import PickerInput from "@/components/Charts/PickerInput.vue";
import Axios from "axios";
import {axiosInstance} from "@/axios/config";

export default {
  components: {  PickerInput },
  data() {
    return {
      adviser_id: 0,
      allStatus: ["الكل", "استشاري مؤرشف", "استشاري قائم"],
      selectedAgents: [],
      selectedManagers: [],
      managerNames: [],
      agentNames: [],
      selectedManager: [],
      mangers: [],
      agents: [],
      status: null,
      filterObj: {
        endDate: "",
        startDate: "",
        status: "استشاري قائم",
        range: "",
        dayNumber: "",
        managerId: [],
        agentId: [],
      },
    };
  },

  watch: {
    selectedManagers(val) {
      this.selectedManager = val;
      this.filterObj.managerId = val;
      this.getMangersAndAgents("agent", this.status);
    },

    selectedAgents(val) {
      this.filterObj.agentId = val;
    },

    "filterObj.status": function (newStatus, oldStatus) {
      this.status = newStatus;
      switch (newStatus) {
        case "استشاري قائم":
          // this.getMangersAndAgents("manager", 1);
          this.getMangersAndAgents("agent", 1);
          break;
        case "استشاري مؤرشف":
          // this.getMangersAndAgents("manager", 0);
          this.getMangersAndAgents("agent", 0);
          break;
        case "الكل":
          // this.getMangersAndAgents("manager");
          this.getMangersAndAgents("agent");
          break;
        default:
          break;
      }
    },
  },

  methods: {
    handleFilter() {
      this.$emit("handleFilter", this.filterObj);
    },
    getSelectedValueManger(selectedValue) {
      this.selectedManagers = selectedValue;
    },

    getSelectedValueAdviser(selectedValue) {
      this.selectedAgents = selectedValue;
    },

    targetEndDate(endDate) {
      this.filterObj.endDate = endDate;
    },

    targetStartDate(startDate) {
      this.filterObj.startDate = startDate;
    },

    getMangersAndAgents(role, status = "") {
      this.agentNames = [];
      let body = new FormData();

      body.append("role", role);

      body.append("adviser_id[0]", this.adviser_id);

      if (status !== "") {
        body.append("status", status);
      }

      // if (this.selectedManagers.length) {
      //   const managerProperties = {};

      //   this.selectedManagers.forEach((item, index) => {
      //     body.append([`manager_id[${index}]`], item.id);
      //   });
      // }

      axiosInstance.post(`/employee/admin/filterUsers`,
        body,
        { headers: this.request_headers() }
      ).then((res) => {
        if (role === "manager") {
          this.managerNames = res["data"]["payload"];
          this.managerNames.map((item) => {
            item["text"] = item["name"];
            item["color"] = "red";
            return item;
          });
        } else {
          this.agentNames = res["data"]["payload"];
          this.agentNames.map((item) => {
            item["text"] = item["name"];
            item["color"] = "red";
            return item;
          });
        }
      });
    },
  },

  created() {
    // this.getMangersAndAgents("manager");
    this.adviser_id = JSON.parse(
        document.cookie
          .split(";")
          .map((coki) => coki.split("="))
          .reduce(
            (acc, [key, val]) => ({
              ...acc,
              [key.trim()]: decodeURIComponent(val),
            }),
            {}
          )["wsataJwt"]
      )["agent_id"];
  },
};
</script>
